enum RouteUrl {
  ModelChooser = 'model-chooser',
  ModelViewer = 'model-viewer',
}

export default RouteUrl;
